import React from 'react';

import '../styles/componentStyles/RadioButton.css';

interface RadioButtonProps {
  label: string;
  name: string;
  value: string;
  checked: boolean;
  // eslint-disable-next-line no-unused-vars
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  isSelected?: boolean;
  isRequired?: boolean;
  ariaLabel?: string;
}

function RadioButton({
  label,
  name,
  value,
  checked,
  onChange,
  className = 'alc-btn sm',
  isSelected,
  isRequired,
  ariaLabel,
}: RadioButtonProps) {
  return (
    <label
      className={`radio-button ${className} ${isSelected ? 'selected' : ''}`}
      htmlFor={`${name}-${value}`}
    >
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        id={`${name}-${value}`}
        required={isRequired}
        aria-label={ariaLabel}
      />
      <span>{label}</span>
    </label>
  );
}

export default RadioButton;
